import { useEffect } from "react";
import type { RefreshMethod } from "../types";
import { tokenRefreshInterceptor } from "../utils";

export function useTokenRefreshInterceptor(
  refresh: RefreshMethod,
  isAuthenticated: boolean,
) {
  useEffect(() => {
    tokenRefreshInterceptor.setRefreshMethod(refresh);
  }, [refresh]);

  useEffect(() => {
    tokenRefreshInterceptor.setSessionOpen(isAuthenticated);
  }, [isAuthenticated]);
}
